import { useBlockEditorContext } from "@circle-react-uikit/TipTapBlockEditor/BlockEditorContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Button } from "@circleco/compass/components/Button";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNodeViewProps } from "@tiptap/react";
import { NodeViewWrapper } from "@tiptap/react";

import { t } from "@/i18n-js/instance";

import { PaywallOptions } from "./PaywallOptions";

export const Renderer = ({
  editor,
  node,
  deleteNode,
  getPos,
  selected,
}: ReactNodeViewProps) => {
  const isEditable = editor.isEditable;
  const { isWithinEmailEditor } = useBlockEditorContext() || {};

  if (!isWithinEmailEditor) return null;

  const { title, description, button_text } = node.attrs;

  return (
    <NodeViewWrapper as="div" className="group relative my-6">
      <div className="flex flex-col gap-6">
        <div
          className={classNames(
            "bg-primary flex flex-col items-center gap-6 rounded-xl px-8 py-10",
            selected ? "border-2 border-info" : "border border-primary",
          )}
        >
          <div className="flex w-full flex-col items-center gap-3 text-center">
            {title && (
              <Typography
                variant="heading-lg"
                color="primary"
                component="span"
                className="w-full"
              >
                {title}
              </Typography>
            )}
            {description && (
              <Typography
                variant="body-md"
                color="primary"
                component="p"
                className="!m-0 w-full"
              >
                {description}
              </Typography>
            )}
          </div>
          {button_text && (
            <Button variant="primary" size="lg" tabIndex={-1}>
              {button_text}
            </Button>
          )}
        </div>

        <div className="flex items-center gap-2">
          <div className="flex-1 border-t border-dashed border-hover" />
          <div className="bg-primary flex items-center gap-1 rounded-lg border border-primary px-2 py-[2px]">
            <Icon name="lock" size="sm" color="primary" />
            <Typography
              variant="label-xs"
              color="primary"
              component="span"
              className="whitespace-nowrap"
            >
              {t("email_editor.paywall.premium_content_label")}
            </Typography>
          </div>
          <div className="flex-1 border-t border-dashed border-hover" />
        </div>

        {isEditable && (
          <PaywallOptions
            editor={editor}
            deleteNode={deleteNode}
            getPos={getPos}
            selected={selected}
          />
        )}
      </div>
    </NodeViewWrapper>
  );
};
